// Carries the first-visit picker's answer from its own React root to App.
//
// The picker is painted from index.html (bootPicker in vite.config.ts) and then
// HYDRATED in place by main.tsx, as a separate root, so React adopts the nodes
// that already painted rather than creating new ones. That matters for LCP:
// on 2026-09-25 PSI scored a new React copy of the picker as a fresh, larger
// paint and charged it for the whole bundle (LCP 6.5 s), where the shell copy
// had painted at FCP. A separate root cannot call App's setters, so its answer
// comes through here. Buffered, because nothing guarantees App has subscribed
// by the time someone taps.
type Listener = (slugs: string[]) => void

let pending: string[] | null = null
let listener: Listener | null = null

export function onboardingDone(slugs: string[]): void {
  if (listener) listener(slugs)
  else pending = slugs
}

export function onOnboardingDone(fn: Listener): () => void {
  listener = fn
  if (pending) {
    const slugs = pending
    pending = null
    fn(slugs)
  }
  return () => {
    if (listener === fn) listener = null
  }
}
